import LandingPage from "./routes/landingPage";
import Home from "./routes/home";
import Account from "./routes/account";
import AppBar from "./components/AppBar";
import { Routes, Route } from "react-router-dom";

import { Box } from "@mui/system";
import { observer } from "mobx-react-lite";
import store from "./mobx";
import { useEffect } from "react";
import Snowfall from "react-snowfall";
import { Fade } from "@mui/material";
import MixQuickProductPage from "./routes/mixQuickProductPage";
import Products from "./routes/products";

function RouteContainer() {
  const { isPhone } = store.mediaBreakpointStore;
  const { globalFxStore } = store;

  useEffect(() => {
    if (isPhone === false) {
      store.drawerStore.set.open(false);
    } else if (isPhone === true) {
      store.drawerStore.set.open(false);
    }
  }, [isPhone]);

  return (
    <Box
      height="100vh"
      width="100vw"
      sx={(theme) => {
        return {
          // overflow: "overlay",
          transition: theme.transitions.create("all"),
        };
      }}
    >
      <Fade in={globalFxStore.snowing}>
        <Box>
          <Snowfall
            snowflakeCount={400}
            speed={[1.0, 5.0]}
            color="pink"
            style={{
              zIndex: 1.3e8,
            }}
          />
        </Box>
      </Fade>
      {/* {!onRootPath && <Drawer />} */}
      {/* {!onRootPath && <Drawer />} */}
      {/* {(isPhone && <AppBar />) ||
        (!isPhone && !store.drawerStore.open && <AppBar />)} */}
      {isPhone && <AppBar />}
      <Routes>
        <Route path="/" element={<MixQuickProductPage />} />
        <Route path="/mixquick" element={<MixQuickProductPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/account" element={<Account />} />
        <Route path="/products" element={<Products />} />
      </Routes>
    </Box>
  );
}

export default observer(RouteContainer);
